<template>
  <div id="app">
    <router-view/>
    <template v-if="($route.name != 'login')||($route.name != 'regist')">
      <TabItem>
        <TabBarItem path="/list">
        <img slot="img-icon" src="./assets/img/font-football.png" alt="">
        <img slot="img-icon-active" src="./assets/img/font-football-blue.png" alt="">
        <div slot="text-icon">竞猜</div>
      </TabBarItem>
        <TabBarItem path="/winner">
          <img slot="img-icon" src="./assets/img/list.png" alt="">
          <img slot="img-icon-active" src="./assets/img/list_blue.png" alt="">
          <div slot="text-icon">中奖名单</div>
        </TabBarItem>
        <TabBarItem path="/login">
          <img slot="img-icon" src="./assets/img/user.png" alt="">
          <img slot="img-icon-active" src="./assets/img/user-blue.png" alt="">
          <div slot="text-icon">用户</div>
        </TabBarItem>
      </TabItem>
    </template>
  </div>
</template>

<script>
  import TabItem from './components/common/TabBar'
  import TabBarItem from './components/common/TabBarItem'
    export default {
        name: "App",
        components:{
            TabItem,
            TabBarItem
        }
    }
</script>
<style>
  @import "./assets/css/base.css";
</style>
